import React, {useRef} from "react";

const BasicInfo = ({setState, basicInfoObj, setBasicInfo}) => {
    const businessRef = useRef(null);
    const billingRef = useRef(null);
    const companyNameRef = useRef(null);
    const nameRef = useRef(null);
    const titleRef = useRef(null);

    const handleNext = () => {
        setState("MORE_DETAILS");
    }

    const handleBack = () => {
        setState("INIT");
    }

    const handleSubmit = (ev) => {
        let businessAddress = businessRef.current.value;
        let billingAddress = billingRef.current.value;
        let companyName = companyNameRef.current.value;
        let contactName = nameRef.current.value;
        let contactTitle = titleRef.current.value;

        let detailsObj = {
            businessAddress, billingAddress, companyName, contactName, contactTitle
        }

        setBasicInfo(detailsObj);
        handleNext();
    }

    return (
        <form className="d-flex flex-column sd-form" onSubmit={handleSubmit}>
            <div className="login-title">Tell us more about your business</div>
            <div className="d-flex flex-column">
                <label className="sd-label">Company Name</label>
                <input ref={companyNameRef} type="text" required={true} className="sd-input"/>
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Contact Person Name</label>
                <input ref={nameRef} type="text" required={true} className="sd-input"/>
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Contact Person Title</label>
                <input ref={titleRef} type="text" required={true} className="sd-input"/>
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Business Address</label>
                <input ref={businessRef} type="text" required={true} className="sd-input"/>
            </div>
            <div className="d-flex flex-column">
                <label className="sd-label">Billing Address</label>
                <input ref={billingRef} type="text" required={true} className="sd-input"/>
            </div>
            <div className="d-flex justify-content-center text-center gap-8">
                <div className="login-btn login-secondary-btn w-100" onClick={handleBack}>Back</div>
                <input type="submit" className="login-btn login-primary-btn w-100" value="Continue"></input>
            </div>
        </form>
    )
}

export default BasicInfo;
